// extracted by mini-css-extract-plugin
export default {"card":"InfoCard_card__oDWWv","divider":"InfoCard_divider__jBcW5","header":"InfoCard_header__3iDOH","item":"InfoCard_item__2v0b3"};